var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProyectosBalken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f9f9d;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.97,20.72l1.49-2.79c.08-.14.12-.3.12-.46V3.08c0-.53-.43-.96-.96-.96H.95C.43,2.12,0,2.55,0,3.08v14.39c0,.16.04.32.12.46l1.89,3.46s.39.53.94.4h.02c.21-.06.4-.19.6-.39.02-.04.37-.62.41-.68ZM1.91,4.03h1.76v1.85h-1.76s0-1.85,0-1.85ZM2.79,18.84l-.88-1.68V7.8s1.75,0,1.75,0l-.03,9.48-.85,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,20.86V6.94s0-.02,0-.05h0c0-.11-.03-.21-.06-.3l-.08-.15s-.03-.08-.05-.1L19.29.36c-.17-.23-.43-.36-.71-.36h-9.66c-.49.02-.9.46-.88.95v19.87c-.02.52.39.95.91.98h13.65s.5,0,.5,0c.5-.02.91-.46.89-.95ZM19.09,3.14l2.14,2.83h-2.14v-2.83ZM22.2,19.88h-12.36V1.91h7.33v5.02s.01.02.02.06c0,.14.03.23.06.31,0,.01.02.04.04.06.02.02.04.05.06.08l.04.08s.04.08.07.1c.06.06.15.11.24.16l.07.05c.11.05.23.07.36.07h4.07v12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyectosBalken);
export default __webpack_public_path__ + "static/media/proyectos_BALKEN.71036d428b05e330e6bb70fdb545e1a9.svg";
export { ForwardRef as ReactComponent };